export enum REGISTERED_VIA {
  ACCOUNT = 'account-web',
  SNOW = 'snow_web',
  ONSEN = 'onsen_web',
  ACTIVITY = 'activity_web',
  YADO = 'yado_web',
  TICKET = 'ticket_web',
  KAIMONO = 'kaimono_web',
  MEDIA = 'media_web',
  TOP = '',
  INSURANCE = 'insurance_web',
}
